import { XyoErc20Wrapper } from '@xyo-network/sdk-xyoworld-js'
import { PropsWithChildren, useContext, useEffect, useState } from 'react'

import { EthersContext } from '../Ethers'
import { CurrencyContext } from './Context'

interface Props {
  enabled?: boolean
}

export const CurrencyLoader: React.FC<PropsWithChildren<Props>> = (props) => {
  const enabled = true
  const { signer, provider, currentNetwork } = useContext(EthersContext)
  const [erc20, setErc20] = useState<XyoErc20Wrapper>()
  const [reset, setReset] = useState(false)

  const currencyAddress = currentNetwork?.addresses?.currency

  useEffect(() => {
    if (enabled) {
      let erc20 = undefined
      if (currencyAddress && provider && enabled) {
        erc20 = new XyoErc20Wrapper(currencyAddress, provider, signer ?? undefined)
      }

      setErc20(erc20)
    }
  }, [currentNetwork, signer, provider, currencyAddress, enabled])

  const refresh = () => {
    setReset(!reset)
  }

  return <CurrencyContext.Provider value={{ erc20, refresh }} {...props} />
}
